import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import wretch from 'wretch';
import HorizontalBorderedStory from '../../molecules/horizontal-bordered-story';
import TitleWithDivider from '../../molecules/titles/with-divider';
import ListHeaderTitle from '../../atoms/list-header-title';
import './not-found.module.css';
class NotFoundPageBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stories: [],
      heading: 'Top Stories'
    };
  }

  componentDidMount() {
    wretch(`${this.props.sketchesHost}/api/v1/collections/above-the-fold?item-type=story&limit=6`)
      .get()
      .json(response => {
        this.setState({
          stories: get(response, ['items'])
          // heading: get(response, ['name'])
        });
      });
  }

  render() {
    return (
      <div>
        <div styleName="not-found-wrapper">
          <div className="container">
            <h1 styleName="not-found-error">404</h1>
            <div styleName="error-message">
              Oops, Page not Found
              <div styleName="error-box">
                Unfortunately, this page does not exist
                <span styleName="divider">or</span>
              </div>
              <div>
                <a styleName="return-link" href="/">
                  Go to Homepage
                </a>
              </div>
              <div styleName="stories-container-note">or check your URL</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div styleName="stories-parent">
            <div styleName="stories-header">
              <div styleName="stories-heading">
                <TitleWithDivider>
                  <ListHeaderTitle title={this.state.heading} />
                </TitleWithDivider>
              </div>
            </div>
            <div styleName="stories-container">
              {this.state.stories.map((story, index) => (
                <React.Fragment key={index}>
                  <HorizontalBorderedStory story={story} key={story.id} />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NotFoundPageBase.propTypes = {
  sketchesHost: PropTypes.string
};

const mapStateToProps = state => ({
  sketchesHost: get(state.qt, ['config', 'publisher', 'sketches_host'], '') || ''
});

export const NotFoundPage = connect(mapStateToProps, {})(NotFoundPageBase);
